var locale = {
  placeholder: 'រើសម៉ោង',
  rangePlaceholder: ['ម៉ោងចប់ផ្ដើម', 'ម៉ោងបញ្ចប់']
};
export default locale;